import React, { useCallback, useEffect, useState } from "react";
import { IAgendamentoDTO } from "../../../types/agendamento";
import { useSearchParams } from "react-router-dom";
import { useContextSite } from "../../../context/Context";
import { Agendamento } from "../../../services/Agendamento";
import { toast } from "react-toastify";
import { Pagamento } from "../../../services/Pagamento";
import { useMediaQuery } from "react-responsive";
import { IFaturaDTO } from "../../../types/pagamento";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";

export const useInspectionTemplate = () => {
  const [agendamento, setAgendamento] = useState<IAgendamentoDTO>(
    {} as IAgendamentoDTO
  );
  const [fatura, setFatura] = useState<IFaturaDTO>({} as IFaturaDTO);
  let [searchParams] = useSearchParams();
  const { setIsLoad } = useContextSite();
  const id = searchParams.get("id");
  const isMobile = useMediaQuery({ maxWidth: "640px" });

  const getAgendamento = useCallback(() => {
    setIsLoad(true);
    Agendamento.getById({ uuid: id })
      .then(({ data }) => {
        setAgendamento(data);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }, []);

  const getFatura = useCallback(() => {
    Pagamento.consultarFatura({ uuidAgendamento: id })
      .then(({ data }) => {
        const value = data?.content?.find(
          (f) => f.status === StatusPagamentoEnum.pending || f.status === StatusPagamentoEnum.paid
        );
        setFatura(value);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      );
  }, []);

  useEffect(() => {
    if (id) {
      getAgendamento();
      getFatura();
    }
  }, [id]);

  function handleDownload() {
    setIsLoad(true);
    Agendamento.downloadRecibo({ uuidAgendamento: id })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  return { agendamento, handleDownload, isMobile, fatura };
};
